import { apiClient } from './client';
import { AppResponse } from '../types';

export interface AppRequest {
  name: string;
  slug: string;
  clientId: string;
  clientSecret?: string;
  authUrl: string;
  tokenUrl: string;
  scopes: string;
}

export const getApps = () =>
  apiClient.get<AppResponse[]>('/api/apps').then(r => r.data);

export const createApp = (req: AppRequest) =>
  apiClient.post<AppResponse>('/api/apps', req).then(r => r.data);

export const updateApp = (id: string, req: AppRequest) =>
  apiClient.put<AppResponse>(`/api/apps/${id}`, req).then(r => r.data);

export const deleteApp = (id: string) =>
  apiClient.delete(`/api/apps/${id}`).then(() => {});
